import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { clearAbility, completeSignIn, decodeJwt, sessionCache, Timer } from "modules/auth";
import { renewToken, signIn, signInAd, signInEpToken, SignInResponse } from "services";
import { ADSignInRequest, EPSignInRequest, SignInRequest } from "services/auth/request";
import { AppDispatch, AppThunk } from "store";

import {
  signInError,
  signInRequest,
  signOut,
  tokenRenewError,
  tokenRenewRequest,
  tokenRenewSuccess,
} from "./reducer";

export const tokenRenew = (): AppThunk => async dispatch => {
    try {
        dispatch(tokenRenewRequest());

        const cache = sessionCache();
        const timer = Timer.getInstance();
        const session = cache.getSession();

        if (session) {
            const response = await renewToken(session.refreshToken);
            const body = decodeJwt(response.data.accessToken);

            cache.updateTokens(response.data.accessToken, response.data.refreshToken);
            timer.start(body.exp);

            dispatch(
                tokenRenewSuccess({
                    accessToken: response.data.accessToken,
                    refreshToken: response.data.refreshToken,
                })
            );
        } else {
            dispatch(logOff());
        }
    } catch (error) {
        dispatch(tokenRenewError());
        dispatch(logOff());
        dispatch(signInError({ errorMessage: "Sesija istekla, ponovno se prijavite." }));
    }
};

export const signInUser =
    (data: SignInRequest | EPSignInRequest | ADSignInRequest): AppThunk =>
    async dispatch => {
        try {
            dispatch(signInRequest());

            let response: AxiosResponse<SignInResponse>;
            let returnUrl: string | undefined = undefined;

            if ("token" in data) {
                returnUrl = data.returnUrl;
                response = await signInEpToken(data.token, returnUrl);
            } else if ("username" in data) {
                response = await signIn(data);
            } else {
                response = await signInAd();
            }

            completeSignIn(
                dispatch as AppDispatch,
                response.data.accessToken,
                response.data.refreshToken,
                returnUrl
            );
        } catch (error: any) {
            const errorMessage = error.response?.data?.statuses?.[0]?.message
                ?? "Greška prilikom prijave";
            dispatch(signInError({ errorMessage }));
            toast.error(errorMessage);
        }
    };

export const logOff = (): AppThunk => async dispatch => {
    const cache = sessionCache();
    cache.removeSession();
    clearAbility();
    dispatch(signOut());
};
